import { Injectable } from '@angular/core';
import { NetworkHelper, NotifierService } from '@wm-libs/core';
import { BehaviorSubject, catchError, Observable, take, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BalanceAndFee, Payout, Payouts } from '../interfaces//payouts.interface';

@Injectable({
  providedIn: 'root',
})
export class PayoutsService {
  readonly apiUrl = `${environment.poolApi}/payouts`;

  private _initPayouts = new BehaviorSubject<Payouts | null>(null);

  readonly initPayouts$ = this._initPayouts.asObservable();

  constructor(private networkHelper: NetworkHelper, private notifier: NotifierService) {}

  getPayouts(params?: { from?: number; count?: number; startTime?: number; endTime?: number }): Observable<Payouts> {
    const defaultParams = {
      from: 0,
      count: 10,
      ...params,
    };

    return this.networkHelper.get<Payouts>(`${this.apiUrl}`, defaultParams).pipe(take(1));
  }

  getBanalceAndFee(): Observable<BalanceAndFee> {
    return this.networkHelper.get<BalanceAndFee>(`${this.apiUrl}/fee`, {});
  }

  createPayouts(address: string, amount: number, tfaCode: string): Observable<Payout> {
    return this.networkHelper
      .post<Payout>(`${this.apiUrl}/create`, {
        address,
        amount,
        tfaCode,
      })
      .pipe(tap(() => this.notifier.setNotifications('POOL.PAYOUT_UPDATED')));
  }

  cancelPayouts(id: number): Observable<Payout> {
    return this.networkHelper.post<Payout>(`${this.apiUrl}/cancel/${id}`, {}).pipe(
      tap(() => this.notifier.setNotifications('POOL.PAYOUT_UPDATED')),
      catchError((err) => {
        if (err.errorCode === 'ACTION_NOT_ALLOWED') {
          this.notifier.setNotifications('POOL.PAYOUT_UPDATED');
        }
        return throwError(() => err);
      })
    );
  }

  setInitPayouts(data: Payouts | null): void {
    this._initPayouts.next(data);
  }
}
